<template>
  <div class="w-100 ">
    <div class="row w-100 mx-md-auto align-items-center nav-200 d-print-none py-1 mx-auto justify-content-around nav-506-wrapper">


      <div class="d-lg-none col-3 "> <slot name="p-1"><NavSidebar500/></slot> </div> <!--sidebar-->

      <div class="col-lg-2 col-5 text-center ">
        <div class=" mb-2  nav-200-logo p-0">
          <m-a class=" nav-200-logo" :href="{name:'Home'}">
            <m-img class="nav-200-logo " :src="findAttributeOnSiteInfo('icon')[0]"
                   :alt="findAttributeOnSiteInfo('site_name')[0]"/>
          </m-a>
        </div>
      </div> <!--logo-->

      <div class="d-lg-none col-4 text-left contact-icon-wrapper-506"><!--start contactus-->
        <div class="row mx-auto justify-content-center align-items-center">
          <div class="col-6"><slot name="p-2"><i class="bi bi-telephone-fill"></i></slot></div>
          <div class="col-6">

            <div class="">
              <template v-if="IsAuthenticated || findAttributeOnSiteInfo('cartType') == 1">
                <m-a class=" nav-200-authentication"
                     :href="{ name: 'ShoppingCart' }">

                  <i class="nav-200-shopping-card-icon my-auto bi bi-cart h3"/>

                </m-a>

                <span class="badge badge-warning position-absolute badge-wrapper-506 rounded-circle"
                      v-if=" orderCount.length != 0 && orderCount.items != undefined">{{
                    orderCount.items.length
                  }} </span>
              </template>
              <template v-else>
                <m-a  class=" d-flex nav-200-basket-counter"
                     :href="{ name: 'UnAuthenticatedShoppingCart' }">
                  <i class="nav-200-shopping-card-icon my-auto bi bi-cart h3"/>

                </m-a>

                <span class="badge badge-warning shopping-cart-counter mx-1 px-2 py-1 mb-3 ">{{ shoppingCartCount }} </span>
              </template>


            </div>


          </div>
        </div>

      </div> <!--contactus-->

      <div class="col-lg-5  nav-200-search-wrapper">
        <component :imageInsideSearch="imageInsideSearchProp" :is="searchInput"
                   class="align-items-center nav-200-search-input"/>
      </div> <!--search-->

      <div class="col-lg-5 d-lg-block nav-200-button-section d-none text-left ">

        <div class="row align-items-center justify-content-end ">
          <m-a class="text-decoration-none nav-200-authentication d-flex border rounded-lg align-items-center py-1 "
               v-if="hideDashboardLink" :href="`${findAttributeOnSiteInfo('dashboard_link')[0]}/dashboard`">
            <i class="nav-200-authentication-icon bi bi-box-arrow-in-left  d-flex align-items-center "></i>
            <span class="mx-1" v-t="`${dashboardButtonText}`"></span>
          </m-a>

          <div class="justify-content-center mx-2 row d-inline-block align-items-center py-1 shopping-card-wrapper">
            <m-a class="col-3 nav-200-authentication" v-if="IsAuthenticated || findAttributeOnSiteInfo('cartType') == 1"
                 :href="{ name: 'ShoppingCart' }">
              <i class="nav-200-shopping-card-icon my-auto bi bi-cart h3"/>
              <span class="badge badge-warning  "
                    v-if=" orderCount.length != 0 && orderCount.items != undefined">{{
                  orderCount.items.length
                }} </span>
            </m-a>

            <m-a v-else class="col-3 d-flex nav-200-basket-counter"
                 :href="{ name: 'UnAuthenticatedShoppingCart' }">
              <i class="nav-200-shopping-card-icon my-auto bi bi-cart h3"/>
              <span class="badge badge-warning shopping-cart-counter ">{{ shoppingCartCount }} </span>
            </m-a>
          </div>
        </div>

      </div> <!--menu-->

      <div class="col-10 mx-auto  d-lg-block  d-none ">
        <div class="row align-items-center py-2">
          <div class="col-2 col-lg-1 p-0 m-0 cursor-pointer">
            <div class="d-flex align-items-center" @click="showMenu">
              <i class="bi h4 m-0" :class="[menuState?'bi-x':'bi-list']"></i>
              <span class="mr-1">{{ megaMenuTitle }}</span>
            </div>
          </div>
          <div class="col-10 col-lg-11">
            <m-menu-3 class="nav-200-inline-menu" :menu-position="menuPosition"/>
          </div>
        </div>
      </div> </div>

    <div class="menu-200-dropdown-disable w-100 nav-200-sub-menu col-6 m-1 mx-auto">
      <div class="d-lg-block d-none">
        <menu200 class="nav-200-main-sub-menu p-1 " :menu-position="megaMenuPosition"/>
      </div>
    </div>


    <teleport to="body">
      <div class="modal fade" id="nav200-modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <div class="modal-body  text-right">
              <menu200 class="nav-200-main-sub-menu" :menu-position="megaMenuPosition"/>
            </div>
          </div>
        </div>
      </div>
    </teleport>


  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import mA from '../../Tags/A'
import mImg from '../../Tags/Img'
import mMenu3 from "../../Menu/Menu3.vue";
import {MenuProps} from "../../Menu/MenuProps";
import Menu200 from "../../Menu/Menu200/Menu200.vue";
import {searchInputs} from "../../Search/Input/SearchInputs";
import NavSidebar500 from "../NavSidebar500/NavSidebar500.vue";

export default {
  name: "Nav506",
  props: {
    hideDashboardLink: {
      type: Boolean,
      default: true
    },
    megaMenuPosition: {
      default: "store_nav"
    },
    megaMenuTitle: {
      default: "منو"
    },
    imageInsideSearchProp: {
      default: ""
    },
    ...MenuProps
  },
  components: {Menu200, mMenu3, mA, mImg, ...searchInputs, NavSidebar500},
  data() {
    return {
      shoppingCartCount: 0,
      menuState: false,
    }
  },
  computed: {
    ...mapGetters({
      isAuth: "User/isAuthenticated",
      storeMenus: "Menu/getAllMenus",
      orderCount: 'ShoppingCart/getSidebarBasketData',
    }),
    IsAuthenticated() {
      return this.$store.getters["User/isAuthenticated"];
    },
    dashboardButtonText() {
      if (!this.isAuth) {
        return this.$t('nav.dashboard_un_auth')
      }
      return this.$t('nav.dashboard_auth')
    }
  },
  methods: {
    showMenu() {
      let mainMenu = document.querySelector('.nav-200-sub-menu');
      if (!this.menuState) { // open menu
        mainMenu.classList.add('menu-200-dropdown-active');
        mainMenu.classList.remove('menu-200-dropdown-disable');
      } else { // close menu
        mainMenu.classList.add('menu-200-dropdown-disable');
        mainMenu.classList.remove('menu-200-dropdown-active');
      }
      this.menuState = !this.menuState;
    },
    countItemsOnUnAuthenticatedShoppingCart() {
      const localProducts = localStorage.products;
      this.shoppingCartCount = localProducts != undefined ? Object.keys(JSON.parse(localStorage.products)).length : 0;
    }
  },
  async mounted() {
    if (this.isDesktopScreen) {
      this.openNav()
    }
    if (this.IsAuthenticated) {
      await this.$store.dispatch("ShoppingCart/userOrderUnpaid");
    }
    window.addEventListener('click', this.countItemsOnUnAuthenticatedShoppingCart);
  }
}
</script>

<style scoped>

.nav-200-logo {
  object-fit: contain;
  max-height: 75px;
}


.nav302-search form {
  background-color: white;
}

.nav302-search input::placeholder {
  text-align: center;
}

.nav302-search input:focus-visible {
  outline: none;
}


.nav-200-basket-counter span {
  font-size: 13px;
}


.nav-200-authentication {
  width: fit-content;
  color: black;
  padding: 4px;
}

.shopping-cart-counter {
  display: flex;
  justify-content: center;
  height: 23px;
  margin-top: 9px;
}

.nav-200-inline-menu :deep(.base-menu-item-icon) {
  display: inline !important;
}

.nav-200-inline-menu :deep(.base-menu-item-text) {
  margin-right: .3rem;
}

.cursor-pointer {
  cursor: pointer;
}

.nav-200-sub-menu {
  position: absolute;
  right: 8%;
  background: #FFFFFF;
  width: fit-content;
  padding: 5px;
  border-radius: 4px;
}

.menu-200-dropdown-disable {
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease, visibility 0.3s ease;
  position: absolute;
}

/* NOTE: don't remove this claas it's use on animation of menu */
.menu-200-dropdown-active {
  opacity: 1;
  visibility: visible;
  transition: opacity 0.3s ease, visibility 0.3s ease;
  position: absolute;
  z-index: 100;
}

.nav-200-authentication-icon, .nav-200-shopping-card-icon {
  font-size: 25px;
}

.nav-200-search-wrapper :deep(.nav-200-search-input) {
  background: #f1f1f1;
  border-radius: 8px;
  padding: 5px;
}

.nav-506-wrapper:deep(.shopping-cart-counter){
  height: 15px ;
}

.nav-506-wrapper:deep(.nav-200-basket-counter span){
  font-size: 10px;
}

.badge-wrapper-506{
  bottom: 0px;
  right: 10px;

}




@media only screen and (max-width: 991px) {
  .nav-200-search-wrapper{
    background-color: #FCFCFC;
    padding: 8px;


  }
}



</style>